import EnglishTerms from "./EnglishTerms";
import SpanishTerms from "./SpanishTerms";

const TermsAndConditionsPage = () => {
  return (
    <div>
      <SpanishTerms />
      <EnglishTerms />
    </div>
  );
};

export default TermsAndConditionsPage;
